import React, { useState } from "react";
/** Styles Import */
import "./Style.css";
/** Components Import */
import { Form } from "react-bootstrap";
/** Icons Import */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faXmark } from "@fortawesome/free-solid-svg-icons";

function SearchInput({
  containerClassName = "",
  formClassName = "",
  formGroupClassName = "",
  contentClassName = "",
  searchIconClassName = "",
  inputClassName = "",
  closeIconClassName = "",
  autoFocus = false,
  isStartIcon = false,
  isEndSearchIcon = false,
  isEndXIcon = false,
  placeholder = "검색어를 입력해주세요.",
  text = "",
  setText = (e) => {},
  onSumit = (e) => {},
}) {
  return (
    <div className={`search-content-search mb-3 ${containerClassName}`}>
      <Form
        className={formClassName}
        onSubmit={(e) => {
          e.preventDefault();
          onSumit(e);
        }}
      >
        <Form.Group className={formGroupClassName}>
          <div className={`search-content-search-content ${contentClassName}`}>
            {isStartIcon && <FontAwesomeIcon className={`search-content-search-icon-start ${searchIconClassName}`} icon={faMagnifyingGlass} />}
            <Form.Control
              className={`search-content-search-input ${isStartIcon ? "search-content-search-input-with-start-icon" : "search-content-search-input-normal"} ${inputClassName}`}
              type='text'
              autoFocus={autoFocus}
              placeholder={placeholder}
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
            {isEndSearchIcon && <FontAwesomeIcon className={`search-content-search-icon-end ${searchIconClassName}`} icon={faMagnifyingGlass} onClick={onSumit} />}
            {isEndXIcon && (
              <FontAwesomeIcon
                className={`search-content-search-icon-end ${closeIconClassName}`}
                icon={faXmark}
                onClick={() => {
                  setText("");
                }}
              />
            )}
          </div>
        </Form.Group>
      </Form>
    </div>
  );
}

export default SearchInput;
